import React from "react";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";

import { constants } from "../global";
import "./FloatingWhatsAppButton.css";

const FloatingWhatsAppButton = ({ onPaidLanding }) => (
  <a
    aria-label="Fale com a Energea pelo WhatsApp"
    className={`floating-whatsapp${onPaidLanding ? " on-paid-landing" : ""}`}
    href={constants.whatsAppUrl}
    rel="noopener noreferrer"
    target="_blank"
  >
    <WhatsAppIcon aria-hidden="true" />
  </a>
);

export default FloatingWhatsAppButton;
